import React from 'react'

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

import AdBanner from '../common/AdBanner';
// import loadGAds from '../common/loadGAds';

import Header from '../common/template/header';
import Footer from '../common/template/footer';
import Routes from './routes';
import LangCheck from '../common/langCheck';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyC_glp9ikN5tK_i9B32aB3_e5nKUmjnOP4",
    authDomain: "webapps-248cf.firebaseapp.com",
    projectId: "webapps-248cf",
    storageBucket: "webapps-248cf.appspot.com",
    messagingSenderId: "976814006097",
    appId: "1:976814006097:web:2a03c91c9d46be7e86bd70",
    measurementId: "G-FCTNQ9VMZD"
  };

const App = (props) => {

    // const [loaded, setLoaded] = useState(false);
    // useEffect(() => {
    //     loadGAds(() => {
    //         setLoaded(true);
    //     });
    // });
    // Initialize Firebase
    const app = initializeApp(firebaseConfig);
    if (app.name && typeof window !== 'undefined') {
        getAnalytics(app);
    }

    return (
        <React.Fragment>
            <div>
                <Header />
                <div className="container mt-main">
                    <AdBanner adSlot='5479609078' />
                    {/* loaded ?: ''*/}
                    <Routes />
                </div>
                <Footer />
                <LangCheck />
            </div>
        </React.Fragment>
    )
}

export default App